import { Store } from '../reducers';
import { User } from '../../types/authentication';

export const selectIsAuthenticated = (state: Store): boolean => state.application.isAuthenticated;
export const selectToken = (state: Store): string => state.application.token;
export const selectUser = (state: Store): User | null => state.application.user;
export const selectIsLoadingApplication = (state: Store): boolean => state.application.isLoading;
